
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Services from "../components/Services";
import HowWeWork from "../components/HowWeWork";
import Newsletter from "../components/Newsletter";
import BackToTopButton from "../components/BackToTopButton";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

const ServicesPage = () => {
  useEffect(() => {
    document.title = "Our Services - DG IT Pvt. Ltd.";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <meta name="description" content="Explore our range of digital services including web development, digital marketing, video production, animation, and design services in Nepal at budget-friendly prices." />
        <meta name="keywords" content="web development, digital marketing, video ads, animation, logo design, Nepal, IT services" />
        <meta property="og:title" content="Our Services - DG IT Pvt. Ltd." />
        <meta property="og:description" content="Explore our range of digital services at budget-friendly prices." />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <Navbar />
      <main className="flex-grow pt-24">
        
        <Services />
        <HowWeWork />
        
        <div className="container mx-auto px-6 py-16">
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-10 text-white shadow-xl">
            <div className="text-center">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Start Your Project?</h2>
              <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                Let's work together to bring your digital vision to life. Our team is ready to help you achieve your goals.
              </p>
              <motion.a
                href="#contact"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-block px-10 py-4 bg-white text-blue-600 font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:translate-y-[-2px]"
              >
                Get Started Now
              </motion.a>
            </div>
          </div>
        </div>

        <Newsletter />
      </main>
      <Footer />
      <BackToTopButton />
      <FloatingSocialButtons />
    </div>
  );
};

export default ServicesPage;
